<template>
	<h2 v-if="sectionTitle != null" class="section__heading" v-html="sectionTitle" />
</template>

<script setup>
import {useI18n} from '#imports'
const { locale } = useI18n()
import {computed} from "vue";
let sectionTitle
const props = defineProps({
	content: Object
})
if(props.content) {
	sectionTitle = computed(() => locale.value === 'en' ? props.content.en : props.content.jp);
}
</script>

<style lang="scss" scoped>
@use '@/assets/sass/variables.scss' as v;
.section__heading {
	font-size: v.$font-size-xl;
	line-height: v.$font-size-xl;
	margin: 0 0 1rem 0;
	@include v.respond-to('small') {
		font-size: v.$font-size-xxl;
		line-height: v.$font-size-xxl;
		margin: 0 0 2rem 0;
	}
	span {
		display: block;
		font-size: v.$font-size-med;
		line-height: v.$font-size-lg * 1.25;
	}
}
</style>
